<template>
  <div class="user-removal-form d-flex flex-row justify-content-center">
    <template v-if="!isConfirming">
      <b-button variant="light" size="sm" @click="isConfirming = true"
        >Remove</b-button
      >
    </template>
    <template v-else>
      <b-button
        class="mr-2"
        size="sm"
        variant="danger"
        @click="submit"
        :disabled="form.$busy"
      >
        <b-spinner small v-if="form.$busy"></b-spinner>
        <span v-else>Confirm</span>
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        @click="isConfirming = false"
        :disabled="form.$busy"
      >
        Cancel
      </b-button>
    </template>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Form from '@/utils/form'
import User from '@/models/User'
import Site from '@/models/Site'

export default {
  props: {
    user: {
      type: [User, Object],
      required: true
    },
    site: {
      type: [Site, Object],
      required: true
    }
  },

  data() {
    return {
      form: new Form({}),
      isConfirming: false
    }
  },

  methods: {
    ...mapActions({
      removeUserFromSite: 'site/removeUserFromSite'
    }),

    async submit() {
      if (this.form.$busy) return

      this.form.$setLoading(true)
      this.$emit('removing')

      await this.removeUserFromSite({
        user: this.user.id,
        site: this.site.site_id
      })
        .then(() => {
          this.$emit('removed', 'Successfully removed user!')
        })
        .catch(error => {
          this.form.$handleError(error)
          this.$emit('removed', this.form.$errorMessage)
        })
        .finally(() => {
          this.form.$setLoading(false)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.user-removal-form {
  button {
    font-size: 12px;
    height: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
